import { useReducer } from "react";
import { Helmet } from "react-helmet";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  FilterContext,
  FilterDispatchContext,
} from "./Components/Context/FilterContext";
import Footer from "./Components/Footer";
import GlobalStyles from "./Components/GlobalStyles";
import Header from "./Components/Header";
import Home from "./Components/Home";
import AboutUs from "./Components/AboutUs";
import Services from "./Components/Services";
import NotFound from "./Components/NotFound";
import { FilterReducer } from "./Components/Reducer/FilterReducer";
//import MobileBottomNav from "./Components/MobileBottomNav";
function App() {
  const initialFilters = JSON.parse(
    localStorage.getItem("PropellerPropertyFilters") || "{}"
  ) || {};
  const [filters, dispatch] = useReducer(FilterReducer, initialFilters);

  return (
    <>
      <Helmet>
        <title>Propeller PH</title>
        <meta name="description" content="Your trusted property seller" />
      </Helmet>
      <div className="App">
        <FilterContext.Provider value={filters}>
          <FilterDispatchContext.Provider value={dispatch}>
            <SkeletonTheme baseColor="#202020" highlightColor="#444">
              <BrowserRouter>
                <GlobalStyles />
                <Header />
                <Routes>
                  <Route path="/" element={<Home />} />
                  {/* <Route path="/search" element={<Search/>} /> */}
                  <Route path="/about-us" element={<AboutUs />} />
                  <Route path="/services" element={<Services />} />
                  {/* Catch-all for extensionless URLs that the CloudFront
                      router forwards to /index.html but don't match any SPA
                      route. Renders a soft 404 with noindex so search engines
                      don't add them to the index. */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
                {/* <MobileBottomNavstyle /> */}
                {/* <MobileBottomNav /> */}
                <Footer />
              </BrowserRouter>
            </SkeletonTheme>
          </FilterDispatchContext.Provider>
        </FilterContext.Provider>
      </div>
    </>
  );
}

export default App;
